
import React from "react";
import {AnalyticsValue} from "@unibuddy/tracking";

export const UniversitySlugAnalyticsValue = ({universitySlug}: {universitySlug: string | null | undefined}) => {
    return universitySlug ? (
        <AnalyticsValue name="universitySlug" value={universitySlug} />
    ) : null;
};